import { createContext } from 'react'
import type { Session, User } from '@supabase/supabase-js'
import type { ProfileRow } from '@/types/database'

export interface AuthValue {
  session: Session | null
  user: User | null
  profile: ProfileRow | null
  /** True until the first session check resolves, so routes don't flash. */
  loading: boolean
  refreshProfile: () => Promise<void>
  signOut: () => Promise<void>
}

export const AuthContext = createContext<AuthValue | null>(null)
